<template>
    <transition name="fade">
        <div class="booking-details sdr-box" v-if="getFlagBookingOutwardFlightSelected === true || getFlagBookingReturnFlightSelected === true">
            <h4>{{ bookingdetails[getCurrentLocale] }}</h4>

            <!-- >>> Cart-Part - Outward Flight ******************************** -->
            <div v-if="getFlagBookingOutwardFlightSelected === true">
                <!-- >>> Flight Data - Outward Flight  ********* -->
                <article class="flight-booking-details">
                    <div class="details">
                        <div class="constant-column-3 timing clearfix">
                            <div class="check-in">
                                <label>{{ takeoff[getCurrentLocale] }}</label>
                                <span>{{ getBookingCart[0].outward.depDT | dateFlightCart }}<br />{{ getBookingCart[0].outward.depDT | momentTime }}</span>
                            </div>
                            <div class="duration text-center">
                                <i class="soap-icon-clock"></i>
                                <span>{{ getBookingCart[0].outward.dur | durationFlightCart }}</span>
                            </div>
                            <div class="check-out">
                                <label>{{ landing[getCurrentLocale] }}</label>
                                <span>{{ getBookingCart[0].outward.desDT | dateFlightCart }}<br />{{ getBookingCart[0].outward.desDT | momentTime }}</span>
                            </div>
                        </div>
                    </div>
                </article>
                <!-- <<< Flight Data - Outward Flight  ********* -->


                <!-- >>> Pax per Pax- Outward Flight  ********** -->
                <article class="detailed-logo" style="padding: 0px;">
                    <div class="details">
                        <center><h2 class="box-title">{{ getBookingDepArprtCode + ' - ' + getBookingDesArprtCode }}<small>{{ getBookingDepArprtName + ' - ' + getBookingDesArprtName }}</small></h2></center>

                        <!-- >>> Loop - Paxes / Prices  -->
                        <div v-for="(pax, index) in getBookingCart" v-bind:key="index">
                            <h4 class="paxheadline">{{ trnslPaxTypes(pax.type) }} {{ pax.counter }}</h4>
                            <!-- >>> FlightPrice -->
                            <span class="price clearfix" v-if="modulo === 'booking'">
                                <a data-toggle="collapse" v-bind:href="'#pax-tax-panel-outward' + pax.id" class="collapsed">
                                    <small class="pull-left">{{ flightprice[getCurrentLocale] }} </small><span class="pull-right" v-tooltip="seetaxes[getCurrentLocale]">{{ pax.outward.totalprice !== undefined ? pax.outward.totalprice : '0' | rndAmntRUAFWZ }}</span>
                                </a>
                            </span>
                            <span class="price clearfix" v-if="modulo === 'services'">
                                <a data-toggle="collapse" v-bind:href="'#pax-tax-panel-outward' + pax.id" class="collapsed">
                                    <small class="pull-left">{{ flightpricesrvcs[getCurrentLocale] }} </small><span class="pull-right">-</span>
                                </a>
                            </span>
                            <div v-bind:id="'pax-tax-panel-outward' + pax.id" class="panel-collapse collapse" v-if="modulo === 'booking'">
                                <dl class="other-details">
                                    <dt class="feature">{{ airfare[getCurrentLocale] }}:</dt><dd class="value">{{ pax.outward.price !== undefined ? pax.outward.price :  '0' | rndAmntRUAFWZ }}</dd>
                                    <dt class="feature">{{ airporttaxes[getCurrentLocale] }}:</dt><dd class="value">{{ pax.outward.taxes !== undefined ? pax.outward.taxes.air :  '0' | rndAmntRUAFWZ }}</dd>
                                    <dt class="feature">{{ aviationtax[getCurrentLocale] }}:</dt><dd class="value">{{ pax.outward.taxes !== undefined ? pax.outward.taxes.avia :'0' | rndAmntRUAFWZ }}</dd>
                                    <dt class="feature">{{ kerosenesurcharge[getCurrentLocale] }}:</dt><dd class="value">{{ pax.outward.taxes !== undefined ? pax.outward.taxes.fuel : '0' | rndAmntRUAFWZ }}</dd>
                                    <dt class="feature">{{ securitycharges[getCurrentLocale] }}:</dt><dd class="value">{{ pax.outward.taxes !== undefined ? pax.outward.taxes.sec :  '0' | rndAmntRUAFWZ }}</dd>
                                    <dt class="feature">{{ servicecharges[getCurrentLocale] }}:</dt><dd class="value">{{ pax.outward.taxes !== undefined ? pax.outward.taxes.srvc :  '0' | rndAmntRUAFWZ }}</dd>
                                </dl>
                            </div>
                            <!-- <<< FlightPrice -->

                            <!-- >>> Seat -->
                            <span class="price clearfix" v-if="pax.outward_seat.seatno !== undefined">
                                <a data-toggle="collapse" v-bind:href="'#pax-delete-seat-outward-' + pax.id_pax + '-' + pax.outward_seat.seatno" v-bind:ref="'pax-delete-seat-outward-' + pax.id_pax + '-' + pax.outward_seat.seatno" class="collapsed">
                                    <small class="pull-left">{{ seat[getCurrentLocale] }}: <b>{{ pax.outward_seat.seatno | truncate(17, '...') }}</b></small><i class="soap-icon-triangle-bottom yellow-color"></i><span class="pull-right" v-tooltip="wannedeleteseat[getCurrentLocale]">{{ pax.outward_seat.price !== undefined ? parseFloat(pax.outward_seat.price) : '0' | rndAmntRUAFWZ }}</span>
                                </a>
                            </span>
                            <div v-bind:id="'pax-delete-seat-outward-' + pax.id_pax + '-' + pax.outward_seat.seatno" class="panel-collapse collapse"  v-if="pax.outward_seat.seatno !== undefined">
                                <a class="button btn-small sundair pull-right" @click.prevent="onClick_DeleteSeat({ id_pax: pax.id_pax, type: 'outward', seat: pax.outward_seat })"><i class="soap-icon-triangle-bottom yellow-color"></i>{{ wannedeleteseat[getCurrentLocale] }}</a><br /><br />
                            </div>
                            <!-- >>> Seat -->

                            <!-- >>> Srvcs -->
                            <span v-for="(srvcs, index2) in pax.outward_srvcs" v-bind:key="index2">
                                <span class="price clearfix">
                                    <a data-toggle="collapse" v-bind:href="'#pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id" v-bind:ref="'pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id" class="collapsed">
                                        <small class="pull-left" v-tooltip="srvcs.description">{{ srvcs.description | truncate(17, '...') }} </small><i class="soap-icon-triangle-bottom yellow-color"></i><span class="pull-right" v-tooltip="wannedelete[getCurrentLocale]">{{ srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0' | rndAmntRUAFWZ }}</span>
                                    </a>
                                </span>
                                <div v-bind:id="'pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id" class="panel-collapse collapse">
                                    <a class="button btn-small sundair pull-right" @click.prevent="onClick_DeleteSrvcs({ id_pax: pax.id_pax, srvcs: srvcs, type: 'outward' })">{{ deletesrvcs[getCurrentLocale] }}</a><br /><br />
                                </div>
                            </span>
                            <!-- >>> Srvcs -->
                        </div>
                        <!-- <<< Loop - Paxes / Prices  -->

                        <dl class="other-details">
                            <dt class="total-price">{{ totaloutwardprice[getCurrentLocale] }}:</dt><dd class="total-price-value">{{ getBookingCartOutwardTotal | rndAmntRUAFWZ }}</dd>
                        </dl>
                    </div>
                </article>
                <!-- <<< Pax per Pax- Outward Flight  ********** -->
            </div>
            <!-- <<< Cart-Part - Outward Flight ******************************** -->



            <!-- >>> Cart-Part - Return Flight ********************************* -->
            <div v-if="getBookingUsersSearchData.rTrip === true && getFlagBookingReturnFlightSelected === true">
                <br />
                <!-- >>> Flight Data - Return Flight  ********** -->
                <article class="flight-booking-details">
                    <div class="details">
                        <div class="constant-column-3 timing clearfix">
                            <div class="check-in">
                                <label>{{ takeoff[getCurrentLocale] }}</label>
                                <span>{{ getBookingCart[0].return.depDT | dateFlightCart }}<br />{{ getBookingCart[0].return.depDT | momentTime }}</span>
                            </div>
                            <div class="duration text-center">
                                <i class="soap-icon-clock"></i>
                                <span>{{ getBookingCart[0].return.dur | durationFlightCart }}</span>
                            </div>
                            <div class="check-out">
                                <label>{{ landing[getCurrentLocale] }}</label>
                                <span>{{ getBookingCart[0].return.desDT | dateFlightCart }}<br />{{ getBookingCart[0].return.desDT | momentTime }}</span>
                            </div>
                        </div>
                    </div>
                </article>
                <!-- <<< Flight Data - Return Flight  ********** -->


                <!-- >>> Pax per Pax- Return Flight  *********** -->
                <article class="detailed-logo" style="padding: 0px;">
                    <div class="details">
                        <!-- >>> Return Flight - Paxes / Prices  -->
                        <center><h2 class="box-title">{{ getBookingDesArprtCode + ' - ' +  getBookingDepArprtCode }}<small>{{ getBookingDesArprtName + ' - ' +  getBookingDepArprtName }}</small></h2></center>


                        <!-- >>> Loop - Paxes / Prices  -->
                        <div v-for="(pax, index) in getBookingCart" v-bind:key="index">
                            <h4 class="paxheadline">{{ trnslPaxTypes(pax.type) }} {{ pax.counter }}</h4>
                            <!-- >>> FlightPrice -->
                            <span class="price clearfix" v-if="modulo === 'booking'">
                                <a data-toggle="collapse" v-bind:href="'#pax-tax-panel-return' + pax.id" class="collapsed">
                                    <small class="pull-left">{{ flightprice[getCurrentLocale] }} </small><span class="pull-right" v-tooltip="seetaxes[getCurrentLocale]">{{ pax.return.totalprice !== undefined ? pax.return.totalprice : '0' | rndAmntRUAFWZ }}</span>
                                </a>
                            </span>
                            <span class="price clearfix" v-if="modulo === 'services'">
                                <a data-toggle="collapse" v-bind:href="'#pax-tax-panel-return' + pax.id" class="collapsed">
                                    <small class="pull-left">{{ flightpricesrvcs[getCurrentLocale] }} </small><span class="pull-right">-</span>
                                </a>
                            </span>

                            <div v-bind:id="'pax-tax-panel-return' + pax.id" class="panel-collapse collapse" v-if="modulo === 'booking'">
                                <dl class="other-details">
                                <dt class="feature">{{ airfare[getCurrentLocale] }}:</dt><dd class="value">{{ pax.return.price !== undefined ? pax.return.price : '0' | rndAmntRUAFWZ }}</dd>
                                <dt class="feature">{{ airporttaxes[getCurrentLocale] }}:</dt><dd class="value">{{ pax.return.taxes !== undefined ? pax.return.taxes.air : '0' | rndAmntRUAFWZ }}</dd>
                                <dt class="feature">{{ aviationtax[getCurrentLocale] }}:</dt><dd class="value">{{ pax.return.taxes !== undefined ? pax.return.taxes.avia : '0' | rndAmntRUAFWZ }}</dd>
                                <dt class="feature">{{ kerosenesurcharge[getCurrentLocale] }}:</dt><dd class="value">{{ pax.return.taxes !== undefined ? pax.return.taxes.fuel : '0' | rndAmntRUAFWZ }}</dd>
                                <dt class="feature">{{ securitycharges[getCurrentLocale] }}:</dt><dd class="value">{{ pax.return.taxes !== undefined ? pax.return.taxes.sec :  '0' | rndAmntRUAFWZ }}</dd>
                                <dt class="feature">{{ servicecharges[getCurrentLocale] }}:</dt><dd class="value">{{ pax.return.taxes !== undefined ? pax.return.taxes.srvc :  '0' | rndAmntRUAFWZ }}</dd>
                                </dl>
                            </div>
                            <!-- <<< FlightPrice -->

                            <!-- >>> Seat -->
                            <span class="price clearfix" v-if="pax.return_seat.seatno !== undefined">
                                <a data-toggle="collapse" v-bind:href="'#pax-delete-seat-return-' + pax.id_pax + '-' + pax.return_seat.seatno" v-bind:ref="'pax-delete-seat-return-' + pax.id_pax + '-' + pax.return_seat.seatno" class="collapsed">
                                    <small class="pull-left">{{ seat[getCurrentLocale] }}: <b>{{ pax.return_seat.seatno | truncate(17, '...') }}</b></small><i class="soap-icon-triangle-bottom yellow-color"></i><span class="pull-right" v-tooltip="wannedeleteseat[getCurrentLocale]">{{ pax.return_seat.price !== undefined ? parseFloat(pax.return_seat.price) : '0' | rndAmntRUAFWZ }}</span>
                                </a>
                            </span>
                            <div v-bind:id="'pax-delete-seat-return-' + pax.id_pax + '-' + pax.return_seat.seatno" class="panel-collapse collapse" v-if="pax.return_seat.seatno !== undefined">
                                <a class="button btn-small sundair pull-right" @click.prevent="onClick_DeleteSeat({ id_pax: pax.id_pax, type: 'return', seat: pax.return_seat })"><i class="soap-icon-triangle-bottom yellow-color"></i>{{ wannedeleteseat[getCurrentLocale] }}</a><br /><br />
                            </div>
                            <!-- >>> Seat -->

                            <!-- >>> Srvcs -->
                            <span v-for="(srvcs, index2) in pax.return_srvcs" v-bind:key="index2">
                                <span class="price clearfix">
                                    <a data-toggle="collapse" v-bind:href="'#pax-delete-service-return-' + pax.id_pax + '-' + srvcs.id" v-bind:ref="'pax-delete-service-return-' + pax.id_pax + '-' + srvcs.id" class="collapsed">
                                        <small class="pull-left" v-tooltip="srvcs.description">{{ srvcs.description | truncate(17, '...') }} </small><i class="soap-icon-triangle-bottom yellow-color"></i><span class="pull-right" v-tooltip="wannedelete[getCurrentLocale]">{{ srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0' | rndAmntRUAFWZ }}</span>
                                    </a>
                                </span>
                                <div v-bind:id="'pax-delete-service-return-' + pax.id_pax + '-' + srvcs.id" class="panel-collapse collapse">
                                    <a class="button btn-small sundair pull-right" @click.prevent="onClick_DeleteSrvcs({ id_pax: pax.id_pax, srvcs: srvcs, type: 'return' })">{{ deletesrvcs[getCurrentLocale] }}</a><br /><br />
                                </div>
                            </span>
                            <!-- >>> Srvcs -->
                        </div>
                        <!-- <<< Loop - Paxes / Prices  -->


                        <dl class="other-details">
                            <dt class="total-price">{{ totalreturnprice[getCurrentLocale] }}:</dt><dd class="total-price-value">{{ getBookingCartReturnTotal | rndAmntRUAFWZ }}</dd>
                        </dl>
                        <!-- <<< Return Flight - Paxes / Prices  -->

                        <!--
                        <br />
                        <button class="btn-large full-width">{{ Number(getBookingCartOutwardTotal) + Number(getBookingCartReturnTotal) | rndAmntRUAFWZ }}<br /><span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span></button> -->
                    </div>
                </article>
                <!-- >>> Pax per Pax- Return Flight  *********** -->
            </div>
            <!-- <<< Cart-Part - Return Flight ********************************* -->



            <!-- >>> Total - Total ********************************************* -->
            <div v-if="getFlagBookingOutwardFlightSelected === true || getFlagBookingReturnFlightSelected === true">
                <br />
                <button class="btn-large full-width sundair" v-bind:class="{ sundairsrvcs: modulo === 'services' }" style="cursor: initial; outline: none !important; outline-style: none !important;">{{ Number(getBookingCartOutwardTotal) + Number(getBookingCartReturnTotal) | rndAmntRUAFWZ }}<br />
                    <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                </button>
            </div>
            <!-- <<< Total - Total ********************************************* -->


            <v-dialog/>
        </div>
    </transition>
</template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                taxesandfees: {
                    en: 'Taxes and Fees',
                    de: 'Steuern und Gebühren'
                },
                airfare: {
                    en: 'Airfare',
                    de: 'Flugpreis'
                },
                airporttaxes: {
                    en: 'Airport taxes',
                    de: 'Flughafengebühren'
                },
                aviationtax: {
                    en: 'Aviation tax',
                    de: 'Luftverkehrssteuer'
                },
                kerosenesurcharge: {
                    en: 'Kerosene surcharge',
                    de: 'Kerosinzuschlag'
                },
                securitycharges: {
                    en: 'Security charges',
                    de: 'Sicherheitsgebühren'
                },
                servicecharges: {
                    en: 'Service charges',
                    de: 'Servicegebühren'
                },
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                bookingdetails: {
                    en: 'Booking Details',
                    de: 'Ihre Buchung',
                },
                bookflightnow: {
                    en: 'book flight now',
                    de: 'Flug buchen',
                },
                seetaxes: {
                    en: 'See Taxes & Fees',
                    de: 'Steuern & Gebühren ansehen',
                },
                totaloutwardprice: {
                    en: 'Total Outward',
                    de: 'Gesamt Hinflug',
                },
                totalreturnprice: {
                    en: 'Total Return',
                    de: 'Gesamt Rückflug',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                child: {
                    en: 'Child',
                    de: 'Kind',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                flightprice: {
                    en: 'Flightprice',
                    de: 'Flugpreis',
                },
                flightpricesrvcs: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                wannedelete: {
                    en: 'Delete Service?',
                    de: 'Service löschen?',
                },
                wannedeleteseat: {
                    en: 'Delete Seat?',
                    de: 'Sitz löschen?',
                },
                deletesrvcs: {
                    en: 'Delete Service/Seat',
                    de: 'Service/Sitz löschen',
                },
                alerttext: {
                    en: 'Are you sure you want to delete the service/seat?',
                    de: 'Wollen Sie den Service/Sitz wirklich löschen?',
                },
                alertno: {
                    en: 'No',
                    de: 'Nein',
                },
                alertyes: {
                    en: 'Yes',
                    de: 'Ja',
                },
                seat: {
                    en: 'Seat',
                    de: 'Sitz',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getBookingCart',
                'getBookingDepArprtCode', // Users Search Data, Part 1
                'getBookingDesArprtCode',
                'getBookingDepArprtName',
                'getBookingDesArprtName',
                'getBookingUsersSearchData', // Users Search Data, Part 2
                'getBookingCartOutwardTotal', // Summed up Outward ALL
                'getBookingCartReturnTotal', // Summed up Return ALL
                'getFlagBookingOutwardFlightSelected', // CONTROL FLAG
                'getFlagBookingReturnFlightSelected', // CONTROL FLAG
                'getBookingCartSeatsCellId', // get cellid (in comment field)
                'getBookingSeatReservationLockingCodeResults',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * dateFlightCart()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            dateFlightCart: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
                // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

            }, // dateFlightCart()

            /*******************************************************************
            * durationFlightCart()
            *
            * Desc: Calculates "Travel Time".
            *
            * @param {int} a (duration in seconds)
            * @return {string}
            */
            durationFlightCart: function(a) {

                let hours = Math.floor(a / 3600),
                    minutes = Math.floor(a / 60) - hours * 60,
                    hours_txt = 'S', // H
                    minutes_txt = ' h'; // M


                if (minutes === 0) {
                    return hours + ':00' + minutes_txt;
                } else if (minutes.toString().length === 1) {
                    return hours + ':0' + minutes + '' + minutes_txt;
                } else {
                    return hours + ':' + minutes + '' + minutes_txt;
                }

            }, // eof durationFlightCart()

            /*******************************************************************
            * truncate()
            *
            * Desc:
            *
            * @param
            * @return {string}
            */
            truncate: function(text, length, clamp) {

                var clamp = clamp || '...';
                var node = document.createElement('div');
                node.innerHTML = text;
                var content = node.textContent;

                return content.length > length ? content.slice(0, length) + clamp : content;

            }, // eof truncate()


        }, // eof filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setBookingUpdateCartViaDeleteSrvcs',
                'actn_setBookingUpdateCartViaDeleteSeat',
                'actn_setServicesUpdateValidateObjectViaDeleteSrvcs',
                'actn_setServicesUpdateValidateObjectViaDeleteSeat',
            ]),


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (DELETE)
            *
            * Desc: UNLock Seat via Lockingcode + Seatno.
            * Note:
            *
            * @param {string} cellId
            * @param {int} id_pax
            * @param {string} type ('out', 'ret')
            * @param {string} seatno
            * @param {bool} lockAfterwards (Should i lock afterwards?)
            */
            call_unlockSeat: function (cellId, id_pax, type, seatno, lockAfterwards) {

                var me = this,
                    lockingCodes = {},
                    lockingcode = '',
                    hdrs = '';


                me.$toc('>>> shared/cart/Cart.vue >>> call_unlockSeat');
                lockingCodes = this.getBookingSeatReservationLockingCodeResults;
                if (type === 'outward') {
                    lockingcode = lockingCodes.outward.response.seatReservationLockingCode;
                }
                if (type === 'return') {
                    lockingcode = lockingCodes.return.response.seatReservationLockingCode;
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.delete('/seatplan/lock_code/' + lockingcode + '/' + seatno, null)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                // Delete in Cart ...
                                me.actn_setBookingUpdateCartViaDeleteSeat({ id_pax: id_pax, type: type })

                                // Delete in Cart ...&& ValidateObject
                                me.actn_setBookingUpdateCartViaDeleteSeat({ id_pax: id_pax, type: type });              // Cart / ValidateObject => 'Booking' && Cart => 'Services'
                                // if (this.modulo === 'services') {
                                me.actn_setServicesUpdateValidateObjectViaDeleteSeat({ id_pax: id_pax, type: type });   // ValidateObject => 'Services'
                                // }
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_unlockSeat()





            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_DeleteSrvcs()
            *
            * Desc: Delete Service.
            * Note: { id_pax: pax.id_pax, srvcs: srvcs, type: 'outward' }
            * Note: I want the 'collapse' to finsih before delete from state!
            *
            * @param {Object} srvcs (selected Srvcs)
            * @return {string}
            */
            onClick_DeleteSrvcs: function(srvcs) {

                var me = this,
                    elem = '';


                me.$toc('>>> shared/cart/Cart.vue >>> onClick_DeleteSrvcs');
                this.$modal.show('dialog', {
                    title: me.wannedelete[me.getCurrentLocale],
                    text: me.alerttext[me.getCurrentLocale],
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {

                                me.$modal.hide('dialog');

                                if(srvcs.type === 'outward') {
                                    elem = 'pax-delete-service-outward-' + srvcs.id_pax + '-' + srvcs.srvcs.id;
                                    this.$refs[elem][0].click();
                                }
                                if(srvcs.type === 'return') {
                                    elem = 'pax-delete-service-return-' + srvcs.id_pax + '-' + srvcs.srvcs.id;
                                    this.$refs[elem][0].click();
                                }


                                // >>> Del from Cart ------------
                                setTimeout(function () {
                                    me.actn_setBookingUpdateCartViaDeleteSrvcs(srvcs);              // Cart / ValidateObject => 'Booking' && Cart => 'Services'
                                    // if (this.modulo === 'services') {
                                    me.actn_setServicesUpdateValidateObjectViaDeleteSrvcs(srvcs);   // ValidateObject => 'Services'
                                    // }
                                }, 650);

                            }
                        },
                    ]
                });

            }, // eof onClick_DeleteSrvcs()

            /*******************************************************************
            * onClick_DeleteSeat()
            *
            * Desc: Delete Seat.
            * Note: e.g.: { id_pax: pax.id_pax, type: 'outward', seat: pax.return_seat }
            * Note: I want the 'collapse' to finsih before delete from state!
            *
            * @param {Object} seat (selected Seat)
            * @return {string}
            */
            onClick_DeleteSeat: function(seat) {

                var me = this,
                    elem = '';


                me.$toc('>>> shared/cart/Cart.vue >>> onClick_DeleteSeat');
                this.$modal.show('dialog', {
                    title: me.wannedelete[me.getCurrentLocale],
                    text: me.alerttext[me.getCurrentLocale],
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {
                                me.$modal.hide('dialog');
                                if(seat.type === 'outward') {
                                    elem = 'pax-delete-seat-outward-' + seat.id_pax + '-' + seat.seat.seatno;
                                    this.$refs[elem][0].click();
                                }
                                if(seat.type === 'return') {
                                    elem = 'pax-delete-seat-return-' + seat.id_pax + '-' + seat.seat.seatno;
                                    this.$refs[elem][0].click();
                                }

                                // >>> Step 2 ---
                                me.onClick_DeleteSeat_2(seat);
                            }
                        }
                    ]
                });

            }, // eof onClick_DeleteSeat()

            /*******************************************************************
            * onClick_DeleteSeat_2()
            *
            * Desc: Delete Seat 2.
            * Note:
            *
            * @param {Object} seat (selected Seat)
            * @return {string}
            */
            onClick_DeleteSeat_2: function(seat) {

                var me = this,
                    id_pax = seat.id_pax,
                    type = seat.type,
                    cellId = this.getBookingCartSeatsCellId({ id_pax: id_pax, type: type }); // getting it from 'comment'


                me.$toc('>>> shared/cart/Cart.vue >>> onClick_DeleteSeat');
                // >>> Unlock -------------------
                me.call_unlockSeat(cellId, id_pax, type, seat.seat.seatno, false);

            }, // eof onClick_DeleteSeat()





            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * trnslPaxTypes()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxTypes: function(type) {

                var me = this,
                    trnsltdType = '';


                me.$toc('>>> shared/cart/Cart.vue >>> trnslPaxTypes');
                switch(type) {
                case 'ADT':
                    trnsltdType = me.adult[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdType = me.child[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdType = me.infant[me.getCurrentLocale];
                    break;
                default:
                    trnsltdType = '';
                }


                return trnsltdType;

            }, // eof trnslPaxTypes()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* >>> Cart --------------------------------------------------------------*/
    article {
        margin-bottom: 2px;
    }
    .detailed-logo .box-title {
        margin-top: 5px;
        padding-bottom: 5px;
    }
    /* .detailed-logo .price, .detailed-logo .feedback {
        border-bottom: 0px;
    } */
    .booking-details .details {
        padding-top: 0px;
    }
    .sdr-box .box-title {
        margin-bottom: 15px;
    }
    .booking-details .other-details dt, .booking-details .other-details dd {
        padding: 0.8em 0;
    }
    .sdr-box .box-title {
        margin-bottom: 5px;
    }
    button.btn-large, input[type="button"].button.btn-large, a.button.btn-large {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    .paxheadline {
        margin-bottom: 4px;
        padding-top: 4px;
    }




    .fade-enter {
        opacity: 0;
    }

    .fade-enter-active {
        transition: opacity 1s;
    }

    .fade-leave {

    }

    .fade-leave-active {
        transition: opacity 1s;
        opacity: 0;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        a.button.btn-large, button.btn-large, input[type=button].button.btn-large {
            font-size: 1.4em; /* Button Text */
        }

        .price {
            font-size: 1.4em;
        }

        h2 {
            font-size: 1.5em;
        }

        .sdr-box {
            padding-top: 10px;
            padding-right: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/cart/Cart.vue